export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    { title: '参数编号', dataIndex: 'argCode', width: 200 },
    { title: '参数名称', dataIndex: 'argName', width: 160, ellipsis: true },
    { title: '参数类型', dataIndex: 'argTypeStr', width: 160 },
    {
      title: '参数可选项',
      dataIndex: 'argValueJson',
      width: 200,
      render: 'jsonRender',
      ellipsis: true,
    },
    { title: '创建人', dataIndex: 'createdByName', width: 160, ellipsis: true },
    { title: '创建时间', dataIndex: 'createdTime', width: 180, itemType: 'dateTime' },
    { title: '状态', dataIndex: 'enabled', width: 90, fixed: 'right', render: 'switchRender' },
    { title: '操作', dataIndex: '#', width: 120, fixed: 'right', render: 'actionRender' },
  ],
  search: [
    { label: '参数名称', name: 'argNameKey' },
    {
      label: '参数类型',
      name: 'argType',
      itemType: 'select',
      data: 'argTypeEnum',
      labelKey: 'description',
    },
    {
      label: '状态',
      name: 'enabled',
      itemType: 'select',
      labelKey: 'label',
      key: 'value',
      data: [
        { label: '启用', value: true },
        { label: '禁用', value: false },
      ],
    },
  ],
  footer: [{ label: '添加参数', type: 'primary', events: ['onClick:onAdd'] }],
}
